import { createContext } from 'react'
import { Clickstream } from '@gojek/clickstream-web'
import clickstream from 'utils/clickstream'

export default createContext<Clickstream>(clickstream)
